module.exports = __webpack_public_path__ + "img/your-subscription-is-about-expire-2-en.d86b5fa.png";